import _extends from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _slicedToArray from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutPropertiesLoose from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js";
var _excluded = ["height", "name", "width", "mode"];
import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { ThemeOptionsContext } from 'docs/src/modules/components/ThemeContext';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Img = styled('img')({
  display: 'inline-block',
  verticalAlign: 'bottom'
});
var neverHydrated = true;
export default function IconImage(props) {
  var heightProp = props.height,
    name = props.name,
    widthProp = props.width,
    modeProp = props.mode,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  var themeOptions = React.useContext(ThemeOptionsContext);
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    firstRender = _React$useState2[0],
    setFirstRender = _React$useState2[1];
  React.useEffect(function () {
    setFirstRender(false);
    neverHydrated = false;
  }, []);
  var defaultWidth;
  var defaultHeight;
  var mode = modeProp != null ? modeProp : themeOptions.paletteMode;
  if (name.startsWith('product-')) {
    defaultWidth = 36;
    defaultHeight = 36;
  } else if (name.startsWith('pricing/x-plan-')) {
    defaultWidth = 13;
    defaultHeight = 15;
  } else if (['pricing/yes', 'pricing/no', 'pricing/time'].includes(name)) {
    defaultWidth = 18;
    defaultHeight = 18;
  }
  var width = widthProp != null ? widthProp : defaultWidth;
  var height = heightProp != null ? heightProp : defaultHeight;

  // First time render with a theme depend image
  if (firstRender && neverHydrated && mode !== '') {
    if (other.loading === 'eager') {
      return /*#__PURE__*/_jsxs(React.Fragment, {
        children: [/*#__PURE__*/_jsx(Img, _extends({
          className: "only-light-mode-v2",
          src: "/static/branding/".concat(name, "-light.svg"),
          alt: "",
          width: width,
          height: height
        }, other, {
          loading: "lazy"
        })), /*#__PURE__*/_jsx(Img, _extends({
          className: "only-dark-mode-v2",
          src: "/static/branding/".concat(name, "-dark.svg"),
          alt: "",
          width: width,
          height: height
        }, other, {
          loading: "lazy"
        }))]
      });
    }

    // Prevent hydration mismatch between the light and dark mode image source.
    return /*#__PURE__*/_jsx(Box, {
      component: "span",
      sx: {
        width: width,
        height: height,
        display: 'inline-block'
      }
    });
  }
  return /*#__PURE__*/_jsx(Img, _extends({
    src: "/static/branding/".concat(name).concat(mode ? "-".concat(mode) : '', ".svg"),
    alt: "",
    loading: "lazy",
    width: width,
    height: height
  }, other));
}